const state = {
  token:'',
  visitNo:'',
  patientId:undefined
}
const mutations = {
  setToken(state, token) {
    state.token = token
  },
  setVisitNo(state, visitNo) {
    state.visitNo = visitNo
  },
  setPatientId(state, patientId) {
    state.patientId = patientId
  },
}
export default {
  state,
  mutations,
}
